import {z} from "zod";

export default z.object({
    title: z.string().optional(),
    html: z.string().optional(),
    image: z
        .object({
            url: z.string(),
            crop: z.string().optional(),
        })
        .optional(),
    image_from_context: z.string().optional()
});
